// RR04 · B-2 · pure helpers for Stage Transfer reversal (mirrors backend DEF-ST-1 rules).

export const meaningfulLen = (s) => String(s || "").replace(/[^0-9A-Za-z]/g, "").length;

export const isReasonValid = (s) => meaningfulLen(s) >= 4;

export const isReversed = (h) => !!(h && (h.void || h.voided_at));

// Normal-screen eligibility: post-DEF-ST-1 rows with persisted lineage and a V2 pair only.
export function reversalEligibility(h, canReverse) {
  if (isReversed(h)) return { ok: false, code: "reversed", label: "Reversed" };
  const lineageOk = Number(h?.lineage_version || 0) >= 1
    && Array.isArray(h?.origins) && h.origins.some((o) => o && o.wo_id);
  if (!lineageOk || !h?.v2_transfer_pair_id) {
    return { ok: false, code: "historical", label: "Needs Review — Historical Transfer" };
  }
  if (!canReverse) return { ok: false, code: "no_permission", label: "Requires Stage Transfer · Reverse permission" };
  return { ok: true, code: "eligible", label: "Reverse this transfer (audit-preserving)" };
}

const KNOWN = {
  STAGE_TRANSFER_ALREADY_REVERSED: "This transfer has already been reversed.",
  STAGE_TRANSFER_DOWNSTREAM_CONSUMED: "Destination stock was already consumed or moved on — reversal not possible.",
  WO_DERIVED_RESOLUTION_FAILED: "Work Order lineage could not be resolved — needs review.",
  REVERSAL_REASON_REQUIRED: "A reversal reason of at least 4 letters or digits is required.",
};

export function errorText(e) {
  if (e?.response?.status === 403) return "You do not have permission to reverse stage transfers.";
  let d = e?.response?.data?.detail;
  // lib/api.js normalises object details to JSON strings — unwrap them here.
  if (typeof d === "string" && d.trim().startsWith("{")) {
    try { d = JSON.parse(d); } catch { /* keep string */ }
  }
  if (typeof d === "string" && d) return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || x?.message || String(x)).join("; ");
  if (d && typeof d === "object") return d.message || KNOWN[d.code] || d.code || "Reverse failed";
  return e?.message || "Reverse failed";
}
